/**
 * xGrid.js CORE
 *
 * Written by Dalius, Lina
 * 2015.11.24 @ Lexita
 *
 * Refactored by Žanas, Dalius
 * Started: ~2017.10.30
 */

/* eslint-disable require-jsdoc */

/*  global objektai
        lang
        module_rights
        pk
        xcontrols
        xstorage
        locale
        log
        xlog
        jsonSave
        notify

        Inputmask
        moment
*/
/*  exported objektai
        xgrid
        xgrid_scrollable
        xgrid_frozen
        xgrid_grouping
        xgrid_pivot
        xgrid_template
        getHtml
        log
        xlog
*/

var xgrid_frozen = function() {},
    xgrid_pivot = function() {},
    xgrid_scrollable = function() {},
    xgrid_template = function() {};

/**
 * xgrid core
 */
class xgrid2 {
    get locale() {
        return locale || 'lt';
    }
    get lang() {
        const langs = {
            lt: {
                exportdata: 'Exportuoti duomenis',
                body      : {
                    // Pranešimas, kai lentelėje duomenų nėra
                    empty: {
                        html: '<h3>' + lang.noData + '</h3>',
                        icon: 'lnr lnr-select'
                    },
                    // Pranešimas, kai įrašų nepavyko rasti
                    empty_filter: {
                        html:
                            '<h3>' +
                            lang.noRecords +
                            '</h3>' +
                            lang.noRecords_note,
                        icon: 'lnr lnr-magnifier'
                    },
                    emptyfiltered: lang.noData_note,
                    emptytotal   : lang.noData
                },
                records: {
                    of     : 'iš',
                    perpage: 'Rodyti puslapyje: ',
                    show   : 'Rodomi įrašai',
                    total  : 'Viso:'
                },
                paging: {
                    first: '<i class="fa fa-angle-double-left"></i>',
                    last : '<i class="fa fa-angle-double-right"></i>',
                    next : '<i class="fa fa-angle-right"></i>',
                    prev : '<i class="fa fa-angle-left"></i>'
                },
                qtip: {
                    date: {
                        title: 'Datos filtras',
                        body : 'Pasirinkite filtrą iš sąrašo'
                    },
                    money: {
                        title: 'Filtro laukas',
                        body : `
                            <table  class="table-simple">
                            <tr> <td class="py-0"> <b>>10</b> </td> <td  class="py-0">rasime reikšmes daugiau už 10</td> </tr>
                            <tr> <td class="py-0"> <b><10</b> </td> <td  class="py-0">rasime reikšmes mažiau už 10</td> </tr>
                            <tr> <td class="py-0"> <b>10..50</b> </td> <td  class="py-0">rasime reikšmes nuo 10 iki 50</td> </tr>
                            </table>`
                    },
                    string: {
                        body: `
                            <table class="table-simple">
                            <tr><td class="py-0"><b>lexit%</b></td> <td class="py-0">tekstas prasideda lexit</td></tr>
                            <tr><td class="py-0"><b>%exita</b></td> <td class="py-0">tekstas baigiasi exita</td></tr>
                            <tr><td class="py-0"><b>exit</b></td>   <td class="py-0">žodyje yra frazė exit</td></tr>
                            <tr><td class="py-0"><b>!exit</b></td>  <td class="py-0">žodyje nėra frazės exit</td></tr>
                            <tr><td class="py-0"><b>=lexita</b></td><td class="py-0">žodis yra lygus lexita</td></tr>
                            <tr><td class="py-0"><b>!</b></td>      <td class="py-0">reikšmė yra tuščia</td></tr>
                            </table>`,
                        title: 'Filtro laukas'
                    }
                }
            },
            en: {
                exportdata: 'Export data',
                body      : {
                    // Pranešimas, kai lentelėje duomenų nėra
                    empty: {
                        icon: 'lnr lnr-select',
                        html: '<h3>' + lang.noData + '</h3>'
                    },
                    // Pranešimas, kai įrašų nepavyko rasti
                    empty_filter: {
                        icon: 'lnr lnr-magnifier',
                        html:
                            '<h3>' +
                            lang.noRecords +
                            '</h3>' +
                            lang.noRecords_note
                    },
                    emptyfiltered: lang.noData_note,
                    emptytotal   : lang.noData
                },
                records: {
                    of     : 'of',
                    perpage: 'Page entry count: ',
                    show   : 'Shown entries',
                    total  : 'Total:'
                },
                paging: {
                    first: '<i class="fa fa-angle-double-left"></i>',
                    last : '<i class="fa fa-angle-double-right"></i>',
                    next : '<i class="fa fa-angle-right"></i>',
                    prev : '<i class="fa fa-angle-left"></i>'
                },
                qtip: {
                    date: {
                        body : 'Choose a filter from the list',
                        title: 'Date filter'
                    },
                    money: {
                        body: `
                            <table  class="table-simple">
                            <tr> <td class="py-0"> <b>>10</b> </td> <td  class="py-0">show values exceeding 10</td> </tr>
                            <tr> <td class="py-0"> <b><10</b> </td> <td  class="py-0">show values less than 10</td> </tr>
                            <tr> <td class="py-0"> <b>10..50</b> </td> <td  class="py-0">show values in range: 10 to 50</td> </tr>
                            </table>`,
                        title: 'Filter field'
                    },
                    string: {
                        body: `<table class="table-simple">
                                <tr><td class="py-0"><b>lexit%</b></td> <td class="py-0">text begins with lexit</td></tr>
                                <tr><td class="py-0"><b>%exita</b></td> <td class="py-0">text ends with exita</td></tr>
                                <tr><td class="py-0"><b>exit</b></td>   <td class="py-0">word contains exit</td></tr>
                                <tr><td class="py-0"><b>!exit</b></td>  <td class="py-0">word doesn't contain exit</td></tr>
                                <tr><td class="py-0"><b>=lexita</b></td><td class="py-0">word equals to lexita</td></tr>
                                <tr><td class="py-0"><b>!</b></td>      <td class="py-0">value is empty</td></tr>
                            </table>`,
                        title: 'Filter field'
                    }
                }
            }
        };
        return langs[this.locale];
    }
    get defaults() {
        return {
            column_sort: true,
            coltypes   :
                params.mysql === true
                    ? {
                          // MySQL draiverio specifika...
                          // Perrašome xgrid komponento stulpelių funkcijas filtravimui
                          date    : 'DATE_FORMAT(@var,\'%Y.%m.%d\')',
                          time    : 'DATE_FORMAT(@var, \'%H:%i\')',
                          datetime: 'DATE_FORMAT(@var,\'%Y.%m.%d %H:%i\')'
                      }
                    : {
                          date    : 'CONVERT(VARCHAR,@var,102)',
                          datetime:
                              'CONVERT(VARCHAR,@var,102) + \' \' +CONVERT(VARCHAR(5),@var,108)',
                          time: 'CONVERT(VARCHAR(5),@var,108)'
                      },
            daterangepicker: {
                autoApply      : true,
                autoUpdateInput: false,
                endDate        : moment(),
                language       : this.locale,
                locale         : {
                    applyLabel      : 'Filtruoti',
                    cancelLabel     : 'Atšaukti',
                    customRangeLabel: 'Rankinis pasirinkimas',
                    daysOfWeek      : ['S', 'P', 'A', 'T', 'K', 'Pn', 'Š'],
                    firstDay        : 1,
                    format          : 'YYYY.MM.DD',
                    fromLabel       : 'Nuo',
                    monthNames      : [
                        'Sausis',
                        'Vasaris',
                        'Kovas',
                        'Balandis',
                        'Gegužė',
                        'Birželis',
                        'Liepa',
                        'Rugpjūtis',
                        'Rugsėjis',
                        'Spalis',
                        'Lapkritis',
                        'Gruodis',
                    ],
                    separator: ' - ',
                    toLabel  : 'Iki',
                    weekLabel: 'Sav'
                },
                ranges: {
                    'Šiandien': [moment(), moment()],
                    'Vakar'   : [
                        moment().subtract(1, 'days'),
                        moment().subtract(1, 'days'),
                    ],
                    'Savaitė'    : [moment().subtract(6, 'days'), moment()],
                    '30 dienų'   : [moment().subtract(29, 'days'), moment()],
                    'Šis mėnesis': [
                        moment().startOf('month'),
                        moment().endOf('month'),
                    ],
                    'Praeitas mėnesis': [
                        moment()
                            .subtract(1, 'month')
                            .startOf('month'),
                        moment()
                            .subtract(1, 'month')
                            .endOf('month'),
                    ]
                },
                startDate: moment().subtract(29, 'days')
            },
            orderby   : '1 ASC',
            pagelength: 20,
            pagestart : 0,
            perpage   : [10, 20, 50, 100, 500],
            filtermin : 5
        };
    }

    /**
     * xGrid inicializacija.
     * @param {JQuery} el - elementas, kuriame inicializuojamas gridas
     * @param {object} params - developer'io xGrid konfiguracija
     * @return {xgrid}
     */
    init(el, params) {
        params.config.pagelength = params.config.pageLength;
        // dalius XBUG, reikia suvienodinti, nes visur dabar naudojamas toks

        var config = $.extend({}, this.defaults, params.config);

        this.el = el;
        this.selector = '#' + el.attr('id');

        this.config = config;
        this.obj = params;

        this.getStorage();

        this.read();

        this.render();
        this.ajaxset(config, this.storage, params);
        this.renderXFilter();

        if (config.ajaxload !== false) {
            this.ajaxload();
        }

        el.show();
        this.delegate(this.tbody, params);
        this.globalEvents();
        // me.setListeners();

        el.on('remove', () => {
            $('div.daterangepicker, div.qtip').remove();
        });

        this.thead.parent().addClass('xgrid--initialized');
        this.thead.parent()[0].xgrid = this;
        this.thead.parent()[0].gridas = this;

        el.trigger('xgrid.init', this);

        return this;

    }

    prepare() {
        // 1. Reorder invisible columns to back (resizing bug)
        const ths = this.el.find('thead th');
        const lastTH = ths.not('[data-visible="false"]').last();
        ths.filter('[data-visible="false"]').insertAfter(lastTH);

        // 2...
    }

    /**
     * Nuskaito paduotus parametrus gridui
     */
    read() {
        var me = this,
            config = this.config;

        this.prepare();

        if (config.sort) {
            $('tr:first', this.el).prepend(`
                    <th data-col="1" data-class="drag-handle" data-sort-click="false" data-resizable="false" data-renderer="html" data-title="" style="width: 28px;"></th>
                `);
        }

        var el = this.el,
            storage = this.storage,
            select = [],
            selectindexes = [],
            columns = [],
            columnsindexes = [],
            aggregate = [],
            sortorder = storage.sort.orderby || config.orderby || '1 asc',
            sort_temp = sortorder.split(' '),
            types = config.coltypes,
            th_all = $('tr:first-child > th', el),
            visibleColumns = 0;

        if (typeof module_rights !== 'undefined') {
            var moduleRights = JSON.parse(module_rights);
            if (typeof moduleRights === 'object') {
                this.moduleRights = moduleRights;
            }
        }

        if (config.fixedRound !== undefined) {
            this.fixedRound =
                config.fixedRound[Object.keys(config.fixedRound)[0]]; // first key
        }

        this.pk_name = config.pk;

        th_all.each((i, element) => {
            var th = $(element),
                type = th.data('type') || 'text',
                co = th.data('col') == 1 ? i : th.data('col'),
                alias = th.data('alias') || co,
                visible =
                    th.data('visible') !== undefined
                        ? th.data('visible').toString()
                        : 'visible',
                col = types[type]
                    ? types[type].replace('@var', co).replace('@var', co)
                    : co, // xaltura reikia replaceAll && visible
                clas = th.data('class'),
                agg = th.data('aggregate') || false,
                renderer = th.data('renderer') || false,
                html,
                search = th.data('search'),
                rowclass = th.data('row-class') || false,
                rowtitle = th.data('row-title') || false,
                mfp = th.data('mfp'),
                sort = th.data('sort') || alias,
                round = th.data('round'),
                zero = th.data('suppress-zero') || false,
                colors = rowclass ? th.data('colors') : null,
                on = th.data('on') || '',
                off = th.data('off') || '',
                bool = th.data('bool') === true ? true : false;

            if (colors) {
                this.colors(el, colors);
            }

            th.attr('data-index', i);
            /* cia truputi xaltura*/

            if (type == 'function') {
                html = th.data('function');
            } else if (renderer === 'checkbox') {
                html = '<input type="checkbox" data-pk="$pk"/>';
                th.html('<input type="checkbox"/>');
            } else if (renderer == 'html') {
                html = me.rendererHTMLButtons(th.html());
                th.html(th.data('title'));
            } else if (renderer == 'img') {
                html = th.data('img');
            }

            th.attr('title', th.text());

            if (agg) {
                // xbug visiska xaltura
                if (agg == 'sumtime') {
                    aggregate.push('CONVERT(VARCHAR(8),' + co + ',108):' + agg);
                    // aggregate.push(co+':'+agg);
                } else {
                    aggregate.push(col + ':' + agg);
                }
            }

            if (i + 1 == sort_temp[0]) {
                th.addClass('sorting_' + sort_temp[1]);
            }

            columns.splice(i, 0, {
                aggregate: agg,
                alias    : alias,
                bool     : bool,
                clas     : clas,
                col      : col,
                edit     : th.data('edit'),
                html     : html,
                index    : i,
                mfp      : mfp,
                off      : off,
                on       : on,
                renderer : renderer,
                renderif : th.data('renderif'),
                round    : round,
                rowclass : rowclass,
                rowtitle : rowtitle,
                search   : search,
                sort     : sort,
                title    : th.html(),
                type     : type,
                visible  : visible,
                isVisible: visible === 'visible',
                zero     : zero
            });

            columnsindexes.splice(i, 0, alias);

            /* visiska xaltura su select.push */

            if (visible == 'false') {
                select.push(col + (th.data('alias') ? ' as ' + alias : ''));
                selectindexes.push(alias);
                th[0].style.display = 'none';
                return;
            } else if (visible == 'optional') {
                th[0].style.display = 'none';
                return;
            } else {
                select.push(col + (th.data('alias') ? ' as ' + alias : ''));
                selectindexes.push(alias);
            }

            visibleColumns++;
        });
        
        this.aggregate = aggregate;
        this.columnsindexes = columnsindexes;
        this.columns = columns;
        this.select = select;
        this.selectindexes = selectindexes;
        this.visiblecolumns = visibleColumns;
    }
    globalEvents() {
        
        $(window)
            .off('resize.xgrid')
            .on('resize.xgrid', () => {
                $('.xgrid--initialized').each((index, element) => {
                    element.xgrid._updateScrollers();
                });
            });

            
        this.os_instance = this.tbody_c
            .overlayScrollbars({
                callbacks: {
                    onScroll: e => {
                        this.thead_c.scrollLeft(e.target.scrollLeft);
                        this.tfoot_c.scrollLeft(e.target.scrollLeft);
                    },
                    onUpdated: () => {
                        this._updateScrollers();
                    }
                }
            })
            .overlayScrollbars();

        this.os_instance.options({
            className: 'os-theme-thin-dark os-theme-thin-edges'
        });
    }

    colors(el, colors) {
        var html =
                '<div class="colors d-flex"><button class="btn btn-default"onclick="$(this).next().collapse(\'toggle\')">Legenda</button><ul class="collapse mb-0 pl-0">',
            arr_colors = JSON.parse('{' + colors.replaceAll('\'', '"') + '}');
        $.each(arr_colors, function(a, b) {
            html += '<li><div class="color ' + a + '"></div>' + b + '</li>';
        });
        html += '</ul></div>';
        el.find('div.actions').before(html);
        var btn = el
                .find('div.actions')
                .prev()
                .find('button'),
            div = btn.parent();
        btn.on('click', function(e) {
            e.stopPropagation();
            div.toggleClass('open');
        });
        $(document).on('click', function() {
            div.removeClass('open');
        });
    }

    setUserConfig() {
        var me = this,
            th_all = $('tr:first th', me.thead),
            config = [];

        $.each(th_all, function(index, th) {
            config.push({
                colindex: Number(th.dataset.index),
                visible : th.style.display === 'none' ? false : true,
                alias   : th.dataset.alias || th.dataset.col,
                thindex : $(th).index()
            });
        });

        me.setStorage('userconfig', config);
    }
    getUserConfig(storage) {
        var me = this,
            config = storage.userconfig,
            select = [],
            selectindexes = [];

        if (Object.keys(config).length === 0) {
            return;
        }

        config.forEach(function(cfg) {
            var column = me.columns[cfg.colindex],
                visible = cfg.visible,
                th = $('th[data-index=' + cfg.colindex + ']', me.thead),
                oldindex = th.index(),
                thindex = cfg.thindex;

            // oldindex;
            if (column === undefined) {
                return;
            }

            if (visible || column.visible == 'false') {
                select.splice(thindex, 0, column.col);
                selectindexes.splice(thindex, 0, column.alias);

                $('tr:first th', me.thead)
                    .eq(oldindex)
                    .show();
                $('tr:last th', me.thead)
                    .eq(oldindex)
                    .show();
                $('td', me.tfoot)
                    .eq(oldindex)
                    .show();
            }

            if (thindex != oldindex) {
                if (thindex === 0) {
                    $('tr:first th', me.thead)
                        .eq(oldindex)
                        .detach()
                        .insertBefore($('tr:first th', me.thead).eq(thindex));
                    $('tr:last th', me.thead)
                        .eq(oldindex)
                        .detach()
                        .insertBefore($('tr:last th', me.thead).eq(thindex));
                    $('td', me.tfoot)
                        .eq(oldindex)
                        .detach()
                        .insertBefore($('td', me.tfoot).eq(thindex));
                    thindex--;
                } else {
                    $('tr:first th', me.thead)
                        .eq(oldindex)
                        .detach()
                        .insertAfter(
                            $('tr:first th', me.thead).eq(thindex - 1)
                        );
                    $('tr:last th', me.thead)
                        .eq(oldindex)
                        .detach()
                        .insertAfter($('tr:last th', me.thead).eq(thindex - 1));
                    $('td', me.tfoot)
                        .eq(oldindex)
                        .detach()
                        .insertAfter($('td', me.tfoot).eq(thindex - 1));
                }
            }

            if (!visible) {
                thindex++;
                $('th:nth-child(' + thindex + ')', me.thead).hide();
                // $('td:nth-child('+(thindex-removed)+')', me.tfoot).remove();
                $('td:nth-child(' + thindex + ')', me.tfoot).hide();

                me.columns[thindex - 1].isVisible = false;
            }
        });

        me._updateScrollers();

        me.select = select;
        me.selectindexes = selectindexes;

        me.modifyselect();
    }
    modifyselect(user) {
        var me = this,
            columns = me.columns,
            select = me.select, // logiskiausia butu sukonstruot selecta is selectindexes
            selectindexes = me.selectindexes,
            columnsnow = [],
            columnsnowindexes = [];
        selectindexes.forEach(function(element, index) {
            columnsnow[index] = columns.find(function(e, i) {
                if (e.alias === element) {
                    columnsnowindexes[index] = e.alias;
                    return true;
                }
            });
        });
        me.columnsnow = columnsnow;
        me.columnsnowindexes = columnsnowindexes;

        me.pk_index = selectindexes.indexOf(me.pk_name);

        if (user === true) {
            me.setUserConfig();
            me.ajax.data.select = select.join(',\r\n');
        }
    }

    // #region ---rendering---
    render() {
        var el = this.el,
            cloned = el.clone(),
            master = $('<div class="xtable-c" />').append(
                $('<div class="xtable-header"/>').html(
                    $('caption', cloned).html()
                )
            );

        el.hide();

        var grid = $('<div class="xtable-grid"/>'),
            thead = cloned
                .removeClass('xtable')
                .children('caption')
                .remove()
                .end()
                .appendTo(grid)
                .wrap('<div class="xtable-thead" />'),
            tbody = $('<tbody />')
                .appendTo(grid)
                .wrap('<div class="xtable-tbody"><table/></div>'),
            tfoot = $('<tfoot />')
                .appendTo(grid)
                .wrap('<div class="xtable-tfoot"><table/></div>');

        grid
            .wrap('<div class="xtable-body"></div>')
            .parent()
            .appendTo(master);

        thead = $('.xtable-thead thead', master);
        tbody = $('.xtable-tbody tbody', master);
        tfoot = $('.xtable-tfoot tfoot', master);

        master = el.after(master).next();
        el.remove();

        this.el = master;

        this.thead = thead;
        this.tbody = tbody;
        this.tfoot = tfoot;
        this.thead_c = thead.parent().parent();
        this.tbody_c = tbody.parent().parent();
        this.tfoot_c = tfoot.parent().parent();

        this.grid = this.tbody_c.parent();

        var th_all = $('th', this.el);

        if (this.aggregate.length > 0) {
            this.tfoot.append(
                $('th', this.thead)
                    .clone()
                    .removeData()
                    .each(function(index, el) {
                        let attrs = {
                            'data-visible' : el.dataset.visible,
                            'data-class'   : el.dataset.class,
                            'data-renderer': el.dataset.renderer
                        };

                        while (el.attributes.length > 0) {
                            el.removeAttribute(el.attributes[0].name);
                        }

                        $(el)
                            .attr(attrs)
                            .html('<div></div>');

                        if (attrs['data-visible']) {
                            el.style.display = 'none';
                        }
                    })
                    .wrapAll('<tr class="xtable-summary"/>')
                    .parent()
            );
        }

        this.renderCaption();
        this.renderFooter();

        let filtershtml = '';
        $('th', el).each(index => {
            filtershtml += this.getSearchFilterHTML(this.columns[index]);
        });
        thead.append('<tr class="filterbar">' + filtershtml + '</tr>');

        this.spacer = $('<th style="width: 0;" data-type="spacer"/>').appendTo(
            thead.add(tfoot).find('tr')
        );

        this.renderHead(th_all);

        this.setSearchFilterEvents();
        this._setTotalWidth();
    }
    renderXFilter() {
        const { table, pk } = this.config;
        const { filters } = this.obj;
        const filterElement = $(
            `<div class="xfilter" id="xfilter-${this.selector}"></div>`
        );
        const filterContainer = this.el.find('.filters').eq(0);
        if (
            typeof filters === 'undefined' ||
            typeof XFilter === 'undefined' ||
            filterContainer.length === 0
        ) {
            return;
        }

        // Every time the filter changes...
        const updateGridByFilter = (newFilter, refresh) => {
            // Save original filter if not not saved.
            // Change XGrid fixedFilter.

            const filterQuery = XFilter.escapeFilter(this.archive) + newFilter;

            // Refresh if clicked
            this.changeFixedFilter(filterQuery, refresh);
        };

        this.XFilter = new XFilter(filterElement, filters, {
            table : table,
            pk_key: pk
        });

        filterElement
            .appendTo(filterContainer)
            .off('xfilter.change')
            .on('xfilter.change', () => {
                updateGridByFilter(this.XFilter.state, true);
            });
        updateGridByFilter(this.XFilter.state, false);
    }
    renderCaption() {
        var me = this,
            el = me.el,
            config = me.config,
            storage = me.storage,
            caption = el.find('.xtable-header');

        var multiselect = caption
                .find('div.filters input')
                .not('.form-control, .related_control'),
            actions = caption.find('div.actions'),
            buttons = actions.find('a, .xswitch, input.archive'),
            xgroup = actions.find('ul.xgroup'),
            filters_group = $('.filters-group');

        // pridedam actions div'ą, jeigu jo nėra. Reikia tokioms funkcijos kaip columns hide. Kai jis true, bet nėra actions div'o XBUG
        if (actions.length === 0) {
            caption.append('<div class="actions"></div>');
            actions = caption.find('div.actions');
        }

        /* FILTERS GROUP */

        filters_group.each(function(i, fg) {
            var div = $(fg),
                filters = me.storage.filter,
                a_all = div.find('a[data-filter]');

            a_all
                .first()
                .parent()
                .addClass('active');

            a_all.each(function(j, el) {
                var a = $(el),
                    parent = a.parent(),
                    filter = a.data('filter');

                var col = filter.split('-');
                if (
                    filters &&
                    filters[col[0]] !== undefined &&
                    filters[col[0]] == filter
                ) {
                    parent.siblings().removeClass('active');
                    parent.addClass('active');
                }

                a.on('click', function(e) {
                    me.search(col[0], filter);
                    parent.siblings().removeClass('active');
                    parent.addClass('active');
                });
            });
        });

        /* END FILTERS GROUP */

        $.each(buttons, (i, button) => {
            var action = $(button);

            if (
                me.moduleRights &&
                me.moduleRights.IsCreate === 0 &&
                !action.hasClass('archive')
            ) {
                action.hide();
            }

            if (action.hasClass('modalwin')) {
                if (action.attr('href') !== 'javascript:;') {
                    action.attr(
                        'href',
                        action.attr('href').indexOf('?') !== -1
                            ? action.attr('href') + '&ajaxmode=1'
                            : action.attr('href') + '?ajaxmode=1'
                    );
                }
                if (pk && !action.data('fk')) {
                    action.data('fk', pk);
                    action.prop('data-fk', pk);
                }

                var btn_states = [];
                var btns_regEx = /btn-primary|btn-success|btn-info|btn-warning|btn-danger|btn-system|btn-default/g;

                if (
                    action.attr('href').indexOf('add') !== -1 &&
                    action.prop('class').match(btns_regEx) === null
                ) {
                    btn_states.push('btn-success');
                } else {
                    btn_states.push('btn-primary');
                }
                action.addClass('btn ' + btn_states.join(' '));
            } else if (action.is('.archive, .xswitch')) {
                var switcher = action.is('.xswitch')
                    ? action.find('input')
                    : action;

                // archive nevisada baigiasi su `;` (programuotojų error)
                // sąlygos operandai aprengti su String, nes kartais fixedFilter ar storage būna `undefined`

                //
                switcher
                    .prop('checked', me.storage.archive === true)
                    .off('change.archive')
                    .on('change.archive', () => {
                        // Įjungeme/Išjungeme archyvą...
                        this.toggleArchive(switcher.prop('checked'));
                    });

                $(() => {
                    this.toggleArchive(
                        switcher.prop('checked'),
                        switcher.prop('checked')
                    );
                });
            }
        });

        $.each(multiselect, function(i, multi) {
            multi = $(multi);
            switch (multi.data('type')) {
                case 'xmultiselect':
                    multi.xmultiselect({
                        grid       : me,
                        filter     : me.storage.filter,
                        fixedFilter: config.fixedFilter
                    });
                    break;
                case 'xdaterange':
                    multi.xdaterange({
                        grid  : me,
                        filter: me.storage.filter
                    });
                    break;
                case 'xmultiselectcustom':
                    multi.xmultiselectcustom({
                        grid        : me,
                        custom_where: me.storage.custom_where,
                        fixedFilter : config.fixedFilter
                    });
                    break;
                case 'xmultiselect3':
                    multi.xmultiselect3({
                        grid       : me,
                        filter     : me.storage.filter,
                        fixedFilter: config.fixedFilter
                    });
                    break;
                default:
                    break;
            }
        });

        var related_control = $('input.related_control'),
            prop = storage.related_control === true ? true : false;

        related_control
            .prop('checked', prop)
            .wrap('<div class="btn-group"></div>');

        related_control.on('change', function() {
            var table = config.table,
                checked = $(this).prop('checked');
            me.setStorage('related_control', checked);
            $.each(multiselect, function(i, el) {
                if ($($(el)).xmultiselect().active.length === 0) {
                    return;
                }
                var field = $(el).data('filter'),
                    filter = me.storage.filter;

                delete filter[field];
                me.setStorage('filter', filter);
            });
            xstorage.clear('grid_' + table);
            location.reload();
        });

        // /////////////////
        var clearStorage = $(
            '<button class="clearStorage btn btn-danger"><i class="fa fa-fw fa-times"></i> Išvalyti filtrus</button>'
        );
        caption.append(clearStorage);

        clearStorage.wrap(
            '<div class="btn-group" style="display: none;"></div>'
        );

        clearStorage.on('click', function() {
            var table = me.selector + config.table;
            xstorage.clear('filter', table);
            xstorage.clear('grid_' + table);

            me.ajax.data.filter = '';

            var input = me.thead.find('input.selected');
            input.val('');
            input.removeClass('selected');

            if (me.chead) {
                var inputCh = me.chead.find('input.selected');
                inputCh.val('');
                inputCh.removeClass('selected');
            }

            $.each(multiselect, function(i, el) {
                var elem;
                switch ($(this).data('type')) {
                    case 'xmultiselect':
                        elem = $(this).xmultiselect();
                        break;
                    case 'xmultiselectcustom':
                        elem = $(this).xmultiselectcustom();
                        break;
                    /* case 'xmultiselectcustom2':
                                        elem = $(this).xmultiselectcustom2();
                                        break;*/
                    case 'xmultiselect3':
                        elem = $(this).xmultiselect3();
                        break;
                    default:
                        break;
                }
                if (elem.active.length !== 0) {
                    elem.reset();
                    elem.setevent();
                }
            });

            me.ajaxload();
        });

        // /////////////////

        $.each(xgroup, function() {
            $(this).xbuttongroup();
        });

        if (config.fixedRound !== undefined) {
            var fixedRoundLang = {
                on : 'Slėpti sk. po kablelio',
                off: 'Rodyti sk. po kablelio'
            };

            actions.prepend(
                '<a href="javascript:;" class="changeDecimals btn btn-sm btn-primary waves-effect waves-light">' +
                    (me.fixedRound == config.fixedRound.on
                        ? fixedRoundLang.off
                        : fixedRoundLang.on) +
                    '</a>'
            );
            actions.find('a:first').click(function() {
                if (me.fixedRound == config.fixedRound.on) {
                    $(this).text(fixedRoundLang.on);
                    me.fixedRound = config.fixedRound.off;
                } else {
                    $(this).text(fixedRoundLang.off);
                    me.fixedRound = config.fixedRound.on;
                }
                me.ajaxload();
            });
        }

        if (!config.columnshide) {
            return;
        }

        var COLUMNS_LIST_KEY = 'xtable-columns-list';

        var columns_html =
            '<ul id="' +
            COLUMNS_LIST_KEY +
            '" data-icon="fa-columns" class="dropdown-filters" data-class="btn  btn-flat btn-icon" data-tooltip-text="Stulpelių rodymas" data-type="default"></ul>';

        if (actions.find('.xswitch, input.archive').length != 0) {
            // cia buvo klaida. Jeigu tikriniami find elementai VISADA reikia tikrinti length parametra.
            actions
                .find('.xswitch, input.archive')
                .eq(0)
                .after(columns_html);
        } else {
            actions.prepend(columns_html);
        }

        var btn = actions.find('#' + COLUMNS_LIST_KEY),
            x = btn.xcheckboxgroup(),
            callback = {};

        actions.find('button#' + COLUMNS_LIST_KEY).one('click', function(e) {
            var response = [];

            $.each(me.columns, function(index, column) {
                if (
                    column.visible === 'false' ||
                    column.renderer === 'checkbox'
                ) {
                    return true;
                }

                response.push({
                    title  : column.title,
                    visible:
                        $('th[data-index="' + index + '"]', me.thead)[0].style
                            .display === 'none'
                            ? false
                            : true,
                    index: index
                });
            });

            callback.click = function(li, index, isActive, event) {
                me.showHideColumns(li, index, isActive, event);
            };

            x.renderlist(response, callback);
        });

        /*
        x.btn.one('click', function(e){
            var cols = $('th:not([data-renderer=checkbox])', el),
                html = '',
                idx = 0;

            $.each(me.columns, function(index, column){
                var title = column.title.replaceAll('"',''),
                    index = column.index,
                    visible = ($('thead th[data-index="'+index+'"]').css('display') == 'none') ? false : true;
                    //log($('thead th[data-index="'+index+'"]').css('display') );

                if (column.visible == 'false' || column.renderer == "checkbox"){
                    return true;
                }

                html +=  '<li class="'+(visible ? 'active' : '')+'" data-name="'+title+'" data-index="'+index+'"></li>';
            });

            x.render(html, function(li, index, isActive, event){
                me.showHideColumns(li, index, isActive, event);
            });
        });
        */
        // groupbuttons.xfiltergroup();
    }

    /**
     * Įjungia/Išjungia archive filtrą priklausomai nuo `this.isArhive`
     */
    get archive() {
        if (typeof this.obj === 'undefined') return '';

        const archiveWhere =
            typeof this.obj.archive === 'function'
                ? this.obj.archive(this.isArchive, this)
                : this.obj.archive;

        return this.isArchive ? archiveWhere : (this.obj.config.fixedFilter || '');
    }
    toggleArchive(state, reload = true) {
        this.isArchive = state ? true : false;
        const multiselect = this.el
            .find('.xtable-header')
            .find('div.filters input')
            .not('.form-control, .related_control');

        if (reload === true && typeof this.obj.archive != 'function') {
            this.changeFixedFilter(
                // (Archyvo sąlyga || Ne archyvo sąlyga) + pasirinktas filtras
                XFilter.escapeFilter(this.archive || this.config.fixedFilter) +
                    ((this.XFilter && this.XFilter.state) || '')
            );
        } else if (typeof this.obj.archive === 'function'){
            this.obj.archive(state);
        }

        $.each(multiselect, (i, xm) => {
            xm = $(xm);
            switch (xm.data('type')) {
                case 'xmultiselect':
                    xm.xmultiselect().setevent();
                    break;
                case 'xmultiselectcustom':
                    xm.xmultiselectcustom().setevent();
                    break;
                case 'xmultiselect3':
                    xm.xmultiselect3().setevent();
                    break;
                default:
                    break;
            }
        });

        // Save to localStorage
        this.setStorage('archive', state);

        // Callback
        if (typeof this.obj.onArchive === 'function') {
            this.obj.onArchive(state);
        }
    }
    renderHead(th_all) {
        var me = this,
            columns = me.columns,
            widths = me.storage.columnswidth,
            TH_SELECTOR = 'th:not([data-type="spacer"])',
            RESIZE_CLASS = 'bbb',
            RESIZE_KEY = '.' + RESIZE_CLASS,
            delegate = function() {
                me.thead
                    .on('click', RESIZE_KEY, e => {
                        e.stopPropagation();
                        e.preventDefault();
                    })
                    .on('mousedown.resize', RESIZE_KEY, function(event) {
                        event.stopPropagation();
                        event.preventDefault();

                        let th = event.currentTarget.parentNode,
                            lastX = event.screenX,
                            startWidth = th.offsetWidth;

                        var mouseMove = function(e) {
                            var offsetX = e.screenX - lastX,
                                width = startWidth + offsetX;

                            if (width > 32) {
                                var index = $(th)
                                    .siblings(':visible')
                                    .addBack()
                                    .index(th);

                                me._setColumnWidth(th, width, index, true);

                                if (me._isLastVisible(th)) {
                                    me._scrollToEnd();
                                }
                            }
                        };

                        var mouseUp = function(e) {
                            e.preventDefault();
                            e.stopPropagation();

                            $(document).off(
                                'mousemove.grid mouseup.grid mouseleave.grid',
                                'body'
                            );

                            // save to localStorage
                            var tempStorage = {};
                            th_all.each(function(index) {
                                tempStorage[index] = me.columns[index].width;
                                this.draggable = true;
                            });

                            me.setStorage('columnswidth', tempStorage);

                            setTimeout(() => (th.disableSort = false), 300);
                        };

                        th.disableSort = true;
                        $(document).on('mousemove.grid', 'body', mouseMove);
                        $(document).on(
                            'mouseup.grid mouseleave.grid',
                            'body',
                            mouseUp
                        );
                    })
                    .on('click.sort', TH_SELECTOR, e => {
                        let th = e.currentTarget;

                        if (
                            !me.config.column_sort ||
                            th.disableSort === true ||
                            th.dataset.sortClick === 'false' ||
                            th.getAttribute('orderable') == false ||
                            e.target.nodeName == 'SPAN' ||
                            e.target.nodeName == 'INPUT' ||
                            $(e.target).has('input').length ||
                            event.which !== 1 // not left mouse button
                        ) {
                            return;
                        }

                        var index = th.dataset.index,
                            column = me.columns[index],
                            current_class = th.className,
                            sort = me.selectindexes.indexOf(column.alias) + 1, // me.select.indexOf(me.columns[me.columnsindexes.indexOf(column.search || column.sort)].col)+1,
                            thead = $(th).closest('thead'), // xbug - turetu but me.thead ?
                            sortorder;
                        $('tr:first th', thead).removeClass();

                        switch (current_class) {
                            case 'sorting_desc':
                                th.className = 'sorting_asc';
                                sortorder = sort + ' asc';
                                break;
                            case 'sorting_asc':
                                sortorder = me.config.orderby;
                                break;
                            default:
                                th.className = 'sorting_desc';
                                sortorder = sort + ' desc';
                                break;
                        }

                        me.setStorage('sort', {
                            orderby: sortorder
                        });
                        me.ajaxload();
                    })
                    .on('click.checkbox', 'th[data-renderer="checkbox"]', e => {
                        $('input[type=checkbox]', me.tbody).prop(
                            'checked',
                            e.currentTarget.querySelector('input').checked
                        );
                    })
                    .on('dragstart', RESIZE_KEY, e => {
                        me.th_ondragstart(e, e.currentTarget.parentNode);
                    })
                    .on('dragover', RESIZE_KEY, e => {
                        me.resize_span_ondragover(
                            e,
                            e.currentTarget,
                            e.currentTarget.parentNode
                        );
                    })
                    .on('drop', RESIZE_KEY, e => {
                        me.resize_span_ondrop(
                            e,
                            e.currentTarget,
                            e.currentTarget.parentNode
                            
                        );
                        
                        return false;
                    });
            },
            f = function(index) {
                let th = th_all[index];

                th.draggable = true; // http://www.cssscript.com/demo/native-html5-drag-and-drop-sortable-js/

                if (columns[index].renderer === 'checkbox') {
                    th.style.width = '28px';
                    th.innerHTML = me._wrap(th.innerHTML, 'label');
                } else {
                    th.innerHTML =
                        me._wrap(th.innerHTML) +
                        '<span class="' +
                        RESIZE_CLASS +
                        '" />';
                }
            };

        // Wrap content, render filters, delegate events
        for (var i = 0; i < th_all.length; i++) {
            f(i);
        }

        delegate();

        // Nustato stulpelių pločius
        // -- 1. Set parent to 100%
        var column_widths = [];

        me.thead.parent()[0].style.width = '100%';
        me.thead_c[0].style.height = '200px'; // FOR DEBUG

        let totalWidth = me.thead.parent().closestVisible(true)[0].offsetWidth;

        // -- 2. Calculate widths
        th_all
            .toArray()
            // 2.1 Before calculating, set localStorage, custom && preset widths
            .map((th, index) => {
                const w = this._getColumnSize(th, index, widths, totalWidth);
                // First set localStorage and preset widths
                // If is not same (> +-3 px)...
                if (w === 0) {
                    return th;
                }
                if (Math.abs(w - th.offsetWidth) > 3) {
                    // Is localStorage || custom || preset
                    me._setColumnWidth(th, w, index);
                }
                return th;
            })
            // 2.2 get final widths
            .map((th, index) => {
                // Get [data-type="preset"], localStorage widths
                // If column has or doesn't have a preset width.
                // Plotis paskaičiuojamas automatiškai
                column_widths.push(
                    this._getColumnSize(th, index, widths, totalWidth)
                );
                return th;
            })
            // 2.3. Set columns to calculated widths
            .forEach((th, index) => {
                me._setColumnWidth(th, column_widths[index], index);
            });

        const emptySize =
            totalWidth -
            column_widths.reduce((acc, w) => (acc += w)) -
            (this.visiblecolumns - 1);
        // debugger;
        me._setEmptyWidth(emptySize);

        // -- 3. Remove parent 100% width
        me.thead.parent().removeAttr('style');

        // -- 4. Set height for thead row (content display: absolute;)
        me._updateScrollers();
    }
    renderFooter() {
        var me = this;

        me.el.append(me.templates.footer);

        var footer = me.el.find('.xtable-footer'),
            paging = footer.find('select'),
            exportbutton = footer.find('.export');

        paging
            .parent()
            .next('a')
            .on('click', function() {
                me.ajaxload();
            });

        exportbutton
            .on('click', function() {
                me.exportExcel();
            })
            .toggle(!(params.grid_hide_export == '1'));

        paging
            .val(me.storage.paging.length || me.config.pagelength)
            .on('change', function() {
                me.loadPage();
            });

        me.footer = footer;
    }
    // #endregion

    // #region --- Paieškos filtrų metodai ---
    getSearchFilterHTML(column) {
        if (!column) return '<th><input type="text" disabled /></th>';

        var alias = column.search || column.alias,
            type = column.type,
            renderer = column.renderer,
            search = column.search,
            filter = this.storage.filter[alias],
            visible =
                column.visible !== 'visible' ? ' style="display:none"' : '',
            filter_val = '';

        if (
            (/html|checkbox/i.test(renderer) === true ||
                /function|x?switch/i.test(type) === true) &&
            !search
        ) {
            return `<th ${visible} class="${
                column.clas
            }"><input type="text" disabled></th>`;
        }

        if (filter && filter.indexOf('-in:') === -1) {
            filter_val =
                filter
                    .split(':')[0]
                    .split('-')[1]
                    .replace('less', '<')
                    .replace('more', '>')
                    .replace('eq', '=')
                    .replace(/between|contains|begins|ends/g, '') +
                filter.split(':')[1].replace(' AND ', '..');
        }

        return `
            <th class="${column.clas}" ${visible}>
                <input type="text" value="${filter_val}"
                    ${
                        filter_val
                            ? 'class="' + this.classes.search.active + '"'
                            : ''
                    }
                />
                <span class="${this.classes.search.clear}"></span>
            </th>
        `;
    }

    clearSearchInput(input) {
        let i = $(input)
            .removeClass(this.classes.search.active)
            .val('')
            .parent()
            .index();
        this.formatFilter('', this.columns[i]);
    }

    /** Apibrėžia stulelių paieškos funkcionalumą */
    setSearchFilterEvents() {
        var me = this,
            columns = me.columns,
            bar = $('tr.filterbar', me.thead),
            active_class = me.classes.search.active;

        // Search clear
        bar
            .on('click.clear-search', '.' + me.classes.search.clear, e => {
                me.clearSearchInput($(e.currentTarget).prev());
            })
            .on('keyup.start-search', 'input, select', e => {
                const el = e.currentTarget;
                if (e.keyCode == 27) {
                    // ESC
                    me.clearSearchInput(el);
                    el.lastSearch = '';
                }

                const string = el.value.trim(),
                    $el = $(el),
                    i = $el.parent().index();

                // Set default `lastSearch` to empty string.
                el.lastSearch = el.lastSearch || '';

                // If empty or pressed ENTER
                if (
                    (string === '' || e.keyCode === 13) &&
                    el.lastSearch !== string
                ) {
                    el.lastSearch = string;
                    me.formatFilter(string, columns[i]);
                    $el.toggleClass(active_class, string.length !== 0);
                }
            });

        me.setSearchFilterTooltips();
    }
    /** Apibrėžia stulelių paieškos tooltip'us */
    setSearchFilterTooltips() {
        let me = this,
            lang = this.lang.qtip,
            bar = $('tr.filterbar', me.thead);

        /** Konfiguracija filtro tooltip'ui
         * @var {function} setupFilterTooltip
         * @param {HTMLElement} input - filtro laukas
         * @param {string} title - tooltip antraštė
         * @param {string} body - tooltip kūnas
         */
        let setupFilterTooltip = function(input, title, body) {
            $(input).tooltipster(
                Object.assign(
                    {},
                    {
                        animation    : 'fade',
                        contentAsHTML: true,
                        arrow        : true,
                        delay        : 300,
                        distance     : 4,
                        side         : 'bottom',
                        theme        : 'material-tooltip'
                    },
                    {
                        content: '<h5 class="my-1">' + title + '</h5>' + body
                    }
                )
            );
        };

        /** Nustatome atitinkamus tooltip'us kiekvienam <input> laukui */

        bar.find('input, select').each((i, input) => {
            if (input.nodeName === 'SELECT' || input.disabled === true) {
                return;
            }

            let column = me.columns[i],
                search = column.search;

            if (search) {
                column = me.columns[me.columnsindexes.indexOf(search)];
            }

            switch (column.type) {
                case 'text':
                    setupFilterTooltip(
                        input,
                        lang.string.title,
                        lang.string.body
                    );

                    break;
                case 'number': // this statement means OR
                case 'money': // this statement means OR
                    Inputmask({
                        regex          : '[0-9<.>]*',
                        placeholder    : '',
                        showMaskOnHover: false,
                        showMaskOnFocus: false
                    }).mask(input);
                    setupFilterTooltip(
                        input,
                        lang.money.title,
                        lang.money.body
                    );

                    break;
                case 'date':
                case 'datetime':
                    setupFilterTooltip(input, lang.date.title, lang.date.body);

                    $(input)
                        .on('apply.daterangepicker', function(ev, picker) {
                            var value;

                            if (column.type == 'datetime') {
                                value =
                                    picker.startDate.format('YYYY.MM.DD') +
                                    ' 00:00-' +
                                    picker.endDate.format('YYYY.MM.DD') +
                                    ' 23:59';
                            } else {
                                value =
                                    picker.startDate.format('YYYY.MM.DD') +
                                    '-' +
                                    picker.endDate.format('YYYY.MM.DD');
                            }

                            $(input)
                                .val(value)
                                .addClass(me.classes.search.active);
                            me.formatFilter(value, column);
                        })
                        .daterangepicker(this.defaults.daterangepicker);

                    break;
            }
        });
    }
    /**
     * Funkcija, kuri escape'ina RegEx'pinius simbolius. Grąžina escape'intą string
     * @param {string} string
     * @return {string}
     */
    escapeRegEx(string) {
        return string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    /** Aprengia rastą substring'ą. Naudojamas paieškos filtre.
     * @param {string} hay - tekstas, kuriame ieškome (šienas)
     * @param {string} needle - tekstas, ko ieškome (adata)
     * @return {string} Pilnas HTML su aprengtu substring
     */
    mark(hay, needle) {
        needle = this.escapeRegEx(needle);

        hay = hay.toString();
        let index = hay.toLowerCase().indexOf(needle.toLowerCase());

        return index == -1
            ? hay
            : hay.replace(new RegExp(needle, 'gmi'), '<mark>$&</mark>');
    }
    /** Pritaiko filtrą paduotam stulpeliui
     * @param {string} value  - filtro reikšmė
     * @param {object} column - stulpelio objektas (iš this.columns masyvo)
     */
    formatFilter(value, column) {
        var me = this,
            alias = column.search || column.alias,
            type = column.type,
            col = column.col,
            filter = me.storage.filter,
            prefix,
            term,
            temp;

        /* xbug dalius, jeigu filtruoja per data-search*/
        if (column.search) {
            temp = me.columns.find(function(e, i) {
                return e.alias == column.search;
            });
            col = temp.col;
        }

        const afterFilter = () => {
            this.setStorage('filter', filter);
            this.loadPage();
        };

        if (value.trim() === '') {
            delete filter[alias];

            afterFilter();

            return;
        }

        if (type === 'text') {
            if (value === '!' && value.length === 1) {
                prefix = 'is';
                term = 'null';
            } else if (value.indexOf('%') !== -1) {
                if (value.indexOf('%') === 0) {
                    prefix = 'ends';
                    term = value.replace('%', '');
                } else {
                    prefix = 'begins';
                    term = value.replace('%', '');
                }
            } else if (value.indexOf('=') !== -1) {
                prefix = 'eq';
                term = value.replace('=', '');
            } else {
                prefix = 'contains';
                term = value;
            }

            if (value.substring(0, 1) === '!' && value.length > 1) {
                prefix = '!' + prefix;
                term = value.slice(1);
            }
        } else if (type === 'money' || type === 'number') {
            if (value.indexOf('..') != -1) {
                temp = value.split('..');

                prefix = 'between';
                term = temp[0] + ' AND ' + temp[1];
            } else if (value.indexOf('>') != -1) {
                prefix = 'more';
                term = value.replace('>', '');
            } else if (value.indexOf('<') != -1) {
                prefix = 'less';
                term = value.replace('<', '');
            } else if (value.indexOf('=') != -1) {
                prefix = 'eq';
                term = value.replace('=', '');
            } else if (value.indexOf('!') != -1) {
                prefix = '!eq';
                term = value.replace('!', '');
            } else {
                // 'contains'
                prefix = 'contains_num';
                term = value;
            }
        } else if (type === 'date') {
            var date = value.split('-');

            if (date[1] && date[0] != date[1]) {
                prefix = 'between';
                term = '\'' + date[0] + '\' AND \'' + date[1] + '\'';
            } else {
                prefix = 'eq';
                term = date[0];
            }
        } else if (type === 'datetime') {
            date = value.split('-');

            prefix = 'between';
            term = '\'' + date[0] + '\' AND \'' + date[1] + '\'';
        }
        // xbug columnas turi ItemSum-DiscountSum
        filter[alias] = col + '-' + prefix + ':' + term;

        afterFilter();
    }
    search(field, select, custom) {
        var me = this,
            filter = !custom ? me.storage.filter : me.storage.custom_where;

        if (select == '' || !select || select == field + '-eq:' + field) {
            delete filter[field];
        } else {
            filter[field] = select;
        }

        me.setStorage(!custom ? 'filter' : 'custom_where', filter);

        me.loadPage();
    }
    // #endregion

    th_ondragstart(e, th) {
        var me = this;

        e.originalEvent.dataTransfer.effectAllowed = 'move';
        e.originalEvent.dataTransfer.setData('Text', th.id);

        me.dragEl = th;
    }

    resize_span_ondrop(e, resize_span, th, el) {
        if (e.stopPropagation) {
            e.stopPropagation(); // stops the browser from redirecting.
        }
        var me = this,        
            elem = $(resize_span).parent(),
            idex = elem.index(),
            elemdrop = $(me.dragEl),
            edex = elemdrop.index(),
            rows = $('tr:not(.xtable-summary)', el),
            rows_l = rows.length,
            cols,
            ths,
            select = me.select,
            selectindexes = me.selectindexes,
            notvisible,
            from,
            to;

        var moveFrom = me.selectindexes.indexOf(
               me.columns[elemdrop.data('index').alias],
            ),
            moveTo = me.selectindexes.indexOf(
                me.columns[elem.data('index').alias],
            );

        if (moveTo <= moveFrom) {
            moveTo++;
        }

        var i;

        if (edex <= idex) {
            // pirmyn
            for (i = 0; i < rows_l; i++) {
                cols = $(rows[i]).children('td');

                if (cols.length === 0) {
                    ths = $(rows[i]).children('th');
                    ths
                        .eq(edex)
                        .detach()
                        .insertAfter(ths.eq(idex));
                } else {
                    cols
                        .eq(moveFrom)
                        .detach()
                        .insertAfter(cols.eq(moveTo));
                }
            }

            ths = $('tr.xtable-summary', me.tfoot).children('td');
            if (ths) {
                ths
                    .eq(edex)
                    .detach()
                    .insertAfter(ths.eq(idex));
            }
        } else {
            for (i = 0; i < rows_l; i++) {
                cols = $(rows[i]).children('td');

                if (cols.length === 0) {
                    ths = $(rows[i]).children('th');
                    ths
                        .eq(edex)
                        .detach()
                        .insertAfter(ths.eq(idex));
                } else {
                    cols
                        .eq(moveFrom)
                        .detach()
                        .insertAfter(cols.eq(moveTo - 1));
                }
            }

            ths = $('tr.xtable-summary', me.tfoot).children('td');
            if (ths) {
                ths
                    .eq(edex)
                    .detach()
                    .insertAfter(ths.eq(idex));
            }
        }

        me.dragEl = null;

        array_move(me.select, moveFrom, moveTo);
        array_move(me.selectindexes, moveFrom, moveTo);

        me.modifyselect(true);
    }
    resize_span_ondragover(e, resize_span, th) {
        var me = this;
        if (resize_span.parentNode == me.dragEl) {
            return;
        }

        if (e.preventDefault) {
            e.preventDefault(); // Allows us to drop.
        }

        e.originalEvent.dataTransfer.dropEffect = 'move';
    }
    delegate(tbody, obj) {
        var me = this;

        if (obj.config.sort) {
            me.sortable(tbody, obj);
        }

        tbody
            .on('click', 'tr', function(event) {
                var target = event.target;

                if (
                    target.nodeName == 'A' ||
                    target.nodeName == 'I' ||
                    target.nodeName == 'LABEL'
                ) {
                    return;
                } else if (
                    target.className == 'html' ||
                    target.nodeName == 'INPUT'
                ) {
                    if (target.className == 'html') {
                        var input = $(target).find('input');
                        if (input[0] && input[0].type == 'checkbox') {
                            input.prop('checked', !input.prop('checked'));
                            return;
                        }
                    } else if (target.nodeName == 'INPUT') {
                        // atvirksciai, nes pirma uzsideda
                        if (target.type == 'checkbox') {
                            var checked = $(target).prop('checked');
                            $(target).prop('checked', checked);
                            return;
                        }
                    }
                }

                if (
                    target.className == 'switch' ||
                    $(target)
                        .closest('td')
                        .hasClass('switch')
                ) {
                    var td = $(target).closest('td'),
                        inputt = td.find('input[type=checkbox]');
                    event.preventDefault(); // nes kai spaudi ant pačio checkbox pasispaudžia ir td elementras
                    inputt.click();

                    return;
                }

                var tr = $(this),
                    pk = tr.data('rowid');
                if (!obj.rowclick || getSelection().toString() || !pk) {
                    return;
                }

                var ii = tbody.find('tr[data-rowid]').index(tr);

                var columns = me.columnsnow,
                    data = me.data[ii].reduce(function(result, item, index) {
                        result[columns[index].alias] = item;
                        return result;
                    }, {});

                me.setActiveRow(pk);

                obj.rowclick(pk, data, tr, event); // xaltura
            })
            .on(
                'click',
                'input[data-type=xswitch]:not([data-custom])',
                function(e) {
                    var input = $(this),
                        tr = input.closest('tr'),
                        pk = tr.data('rowid'),
                        value = input.prop('checked') ? 1 : 0,
                        index = tr
                            .find('td:visible')
                            .index(input.closest('td')),
                        columns = me.columnsnow,
                        col = columns[index];

                    /*
                col = columns.find(function(element, index){
                    return element.type == 'switch';
                }), */

                    // kai naudojamas grido formoje
                    if (input.closest('form').length != 0) {
                        return;
                    }

                    const groupEls = tr.prevAll('tr.group').length;
                    const dataIdx =
                        tr.index() - (groupEls > 0 ? groupEls + 1 : 0);

                    var data = me.data[dataIdx].reduce(function(
                        result,
                        item,
                        index
                    ) {
                        result[columns[index].alias] = item;
                        return result;
                    },
                    {});

                    const switchFunc = obj.onSwitch || obj.switch;

                    if (typeof switchFunc === 'function') {
                        switchFunc(pk, value, data, tr, me, col);
                        return;
                    }

                    var json = {
                        table : obj.config.table,
                        pk_key: obj.config.pk,
                        pk_val: pk
                    };

                    json[col.alias] = value;

                    xcrud.jsonSave(json, null, null);
                }
            );
    }
    setActiveRow(pk) {
        var me = this;
        me.setStorage('record', {
            pk: pk
        });

        $('tr', me.tbody)
            .removeClass(me.classes.active_row)
            .filter('[data-rowid=' + pk + ']')
            .addClass(me.classes.active_row);
    }
    sortable(tbody, obj) {
        var me = this,
            oldindex;

        tbody.sortable({
            axis  : 'y',
            handle: 'td.drag-handle',
            helper: 'clone',
            items : 'tr',
            scroll: tbody.children().length > 20,
            start : function(e, ui) {
                oldindex = ui.item.index() - 1;
                ui.placeholder.height(ui.item.outerHeight());
                ui.placeholder.css('visibility', 'visible');
            },

            update: function(event, ui) {
                var data = me.data,
                    newindex = ui.item.index() - 1,
                    rowData = data[oldindex],
                    prev_data,
                    next_data;

                //  Also sort the `this.data` array (remove old, place in new)
                data.splice(oldindex, 1);
                data.splice(newindex, 0, rowData);

                if (newindex > 0 && newindex < data.length) {
                    prev_data = data[newindex - 1];
                    next_data = data[newindex + 1];
                } else if (newindex == 0) {
                    next_data = data[1];
                } else {
                    prev_data = data[newindex - 1];
                }

                me.data = data;

                if (typeof obj.sort === 'function') {
                    obj.sort(
                        ui.item,
                        data[newindex],
                        ui.item.prev(),
                        prev_data,
                        ui.item.next(),
                        next_data,
                        tbody,
                        me
                    );
                    return;
                }

                var table = me.config.table,
                    pk = me.config.pk,
                    pk_val = ui.item.data('rowid'),
                    sort = me.config.sort,
                    index = me.columns.findIndex(function(obj) {
                        return obj.col == sort;
                    });

                if (index === -1) {
                    event.preventDefault();
                    console.log(sort + ' laukas nerastas tarp columns');
                    return;
                }

                var params = {
                    table                  : table,
                    column                 : sort,
                    pk                     : pk,
                    sort_group_id          : me.config.sort_group_id,
                    sort_group_name        : me.config.sort_group_name,
                    sort_group_custom_where: me.config.sort_group_custom_where,
                    sortFilter: me.config.sortFilter,
                    fixedFilter: me.ajax.data.fixedFilter, //me.config.fixedFilter,
                    prev                   :
                        prev_data && prev_data[index] != null
                            ? prev_data[index]
                            : -1,
                    current:
                        data[newindex][index] != null
                            ? data[newindex][index]
                            : 0,
                    next:
                        next_data && next_data[index] != null
                            ? next_data[index]
                            : 9999
                };

                var errorFunction = function() {
                    xdialog.notify.show(
                        'Klaida',
                        'Nepavyko pakeisti eiliškumo',
                        'warning'
                    );
                };
                
                $.ajax({
                    type    : 'POST',
                    url     : '/php/actions/sort.php',
                    async   : false,
                    data    : params,
                    dataType: 'json',
                    success : function(response) {
                        if(typeof me.config.sortCallback === 'function'){
                            me.config.sortCallback(response.success, params.fixedFilter);
                        }

                        if (response.success === false) {
                            event.preventDefault();
                            errorFunction();
                            return;
                        }
                        var orderby = me.ajax.data.orderby;
                        me.ajax.data.orderby =
                            orderby.indexOf(sort) === -1
                                ? sort + ', ' + orderby
                                : orderby;

                        xdialog.notify.show(
                            'Įvykdyta',
                            'Sėkmingai įvykdyta',
                            'success'
                        );
                    },
                    error: function(response) {
                        errorFunction();
                    },
                    complete: function() {
                        me.ajaxload();
                    }
                });
            }
        });
    }
    ajaxset(config, storage, obj) {
        // debugger;
        // console.log(config);
        // debugger;
        const container = this.thead.closest('.xtable-c');

        this.getUserConfig(storage);

        this.ajax = {
            url     : obj.url || web.zone + '/json/load',
            dataType: 'json',
            type    : 'POST',
            data    : {
                table       : config.table,
                select      : this.select.join(',\r\n'),
                aggregate   : this.aggregate.join(';'),
                start       : storage.paging.start || config.pagestart || 0,
                page        : storage.paging.page || 1,
                filter      : xhelper.obj.toArray(storage.filter).join(';'),
                custom_where: xhelper.obj
                    .toArray(storage.custom_where)
                    .join(';'),
                fixedFilter: obj.config.fixedFilter, // config.fixedFilter, xbug DALIUS
                length     :
                    storage.paging.length ||
                    obj.config.pageLength ||
                    config.pagelength ||
                    20,
                orderby:
                    (config.orderbyForced ? config.orderbyForced + ',' : '') +
                    (storage.sort.orderby || config.orderby),
                group_by: config.group_by, // Naudojamas vizus 04-12
                dt      : 1
            },
            beforeSend: () => {
                if (this.xhr) {
                    this.xhr.abort(['cancel']);
                }
                container
                    .addClass('xtable-loading')
                    .append(
                        '<div class="xtable-loader svg-loader"> <svg viewBox="0 0 32 32" width="32" height="32"> <circle cx="16" cy="16" r="14" fill= "none"></circle> </svg> </div>'
                    );
            },
            success: response => {
                if (!xcrud.json.check_failure(response)) {
                    return;
                }

                this.ajaxsuccess(
                    response.success,
                    response.recordsTotal,
                    response.recordsFiltered,
                    response.data,
                    response.aggregate,
                    storage
                );

                var xeditable = this.columns.find(function(obj) {
                    return obj.renderer === 'xeditable';
                });
                if (xeditable) {
                    xcontrols.init();
                }

                this.tbody
                    .find('i.fa-pencil')
                    .parent()
                    .on('click', e => {
                        // xaltura nes editas, ne per rowclick neuzzymi iraso
                        var tr = $(e.currentTarget).parents('tr'),
                            pk = tr.data('rowid');

                        tr
                            .addClass(this.classes.active_row)
                            .siblings()
                            .removeClass(this.classes.active_row);
                        this.setStorage('record', {
                            pk: pk
                        });
                    });
            },
            error: e => {
                if (e.status === 'cancel') return;
                // console.error('XGRID | Patikrinkite query');
            },
            complete: e => {
                container
                    .removeClass('xtable-loading')
                    .find('.xtable-loader')
                    .remove();
            }
        };

        /* --reikia atstatyti */
        if (config.custom_where) {
            $.extend(this.ajax.data, {
                custom_where: config.custom_where
            });
        }

        this.modifyselect(false);
    }
    ajaxsuccess(success, total, filtered, data, aggregate) {
        var me = this,
            tbody = me.tbody,
            tfoot = me.tfoot,
            columnsnow = me.columnsnow;

        tbody.empty();

        if (!this.fewRecords(filtered, total) || !data) {
            // !data <--laikinas spredimas, jei nepavyko query
            this.onRender();

            return;
        }

        this.data = data;

        // Active row
        tbody
            .append(this.renderPage(data))
            .find('tr[data-rowid=' + this.storage.record.pk + ']')
            .addClass(this.classes.active_row);

        // Sumų skaičiavimas. labai leta vieta --NUSPRĘSTA TVARKYTI 2017-03-10
        for (var key in aggregate) {
            if (aggregate[key]) {
                var columnindex = columnsnow.findIndex((column, idx) => {
                    // xbug visiska xaltura
                    return (
                        column.col == key ||
                        'CONVERT(VARCHAR(8),' + column.alias + ',108)' == key
                    );
                });

                if (columnindex !== -1) {
                    var column = columnsnow[columnindex],
                        sindex = this.selectindexes.indexOf(column.alias),
                        sum = aggregate[key] || 0,
                        html;

                    if (column.round) {
                        html =
                            '~' +
                            sum
                                .toFixed(column.round)
                                .toString()
                                .commafy() +
                            ' ' +
                            (column.renderer ? column.renderer : '');
                    } else {
                        html =
                            sum.toString().commafy() +
                            ' ' +
                            (column.renderer ? column.renderer : '');
                    }

                    $('th', tfoot)
                        .filter(':nth-child(' + (column.index + 1) + ')')
                        .children()
                        .html(html);
                }
            }
        }

        this.renderPagination(data.length, filtered, total);
        const tableImages = tbody
            .find('img')
            .hide()
            .toArray()
            .map(
                img =>
                    new Promise((resolve, reject) => {
                        if (img.complete) resolve(img);
                        img.onload = () => resolve(img);
                        img.onerror = () => resolve();
                    })
            );

        setTimeout(() => {
            // me._updateAll();
            Promise.all(tableImages).then(goodImages => {
                goodImages.forEach(img => {
                    if (img) {
                        img.style.display = '';
                    }
                });
                this._updateScrollers();
            });

            this.onRender();
        }, 0);
    }
    onRender() {
        // if (this.obj.bodyredraw) {
        //     this.obj.bodyredraw(this.tbody, this.data);
        // }
        if (typeof this.obj.bodyredraw === 'function') {
            this.obj.bodyredraw(this.tbody, this.data, this);
        }
    }
    fewRecords(filtered, total) {
        var me = this,
            lang = this.lang,
            thead = me.thead,
            tbody = me.tbody,
            tfoot = me.tfoot,
            footer = me.footer,
            footer_left = footer.find('.footer-left'),
            footer_center = footer.find('.footer-center'),
            footer_right = footer.find('.footer-right'),
            $filterbar = $('tr.filterbar', thead)[0],
            norecords,
            filterbar = me.config.filterbar,
            isSearching = Object.keys(this.storage.filter).length > 0;

        filtered = Number(filtered);
        total = Number(total);

        if (isSearching === false && (total <= this.config.filtermin || filterbar === false)) {
            $filterbar.style.display = $filterbar !== undefined ? 'none' : '';
        } else {
            $filterbar.style.display = '';
        }

        if (me.config.empty === undefined) {
            me.config.empty = {
                icon: lang.body.empty.icon,
                html: lang.body.empty.html
            };
        } else {
            if (me.config.empty.icon === undefined) {
                me.config.empty.icon = lang.body.empty.icon;
            }
            if (me.config.empty.html === undefined) {
                me.config.empty.html = lang.body.empty.html;
            }
        }
        if (me.config.empty_filter === undefined) {
            me.config.empty_filter = {
                icon: lang.body.empty_filter.icon,
                html: lang.body.empty_filter.html
            };
        } else {
            if (me.config.empty_filter.icon === undefined) {
                me.config.empty_filter.icon = lang.body.empty_filter.icon;
            }
            if (me.config.empty_filter.html === undefined) {
                me.config.empty_filter.html = lang.body.empty_filter.html;
            }
        }

        if (total === 0) {
            norecords =
                '<tr><td colspan="' +
                me.visiblecolumns +
                '" class="table-empty">' +
                '<div class="table-empty-content">' +
                (me.config.empty.icon
                    ? '<div class="table-empty-icon">' +
                      '<i class="' +
                      me.config.empty.icon +
                      '"></i>' +
                      '</div>'
                    : '') +
                '<div class="table-empty-text">' +
                me.config.empty.html +
                '</div>' +
                '</div>' +
                '</td></tr>';
        } else if (filtered === 0) {
            norecords =
                '<tr><td colspan="' +
                me.visiblecolumns +
                '" class="table-empty">' +
                '<div class="table-empty-content">' +
                (me.config.empty_filter.icon
                    ? '<div class="table-empty-icon">' +
                      '<i class="' +
                      me.config.empty_filter.icon +
                      '"></i>' +
                      '</div>'
                    : '') +
                '<div class="table-empty-text">' +
                me.config.empty_filter.html +
                '</div>' +
                '</div>' +
                '</td></tr>';

            footer_left.html(
                '<span class="textTotal">Viso: ' + total + '</span>'
            );
        }

        const hide = toggle => {
            // if (footer_center[0] !== undefined) {footer_center[0].style.display = toggle ? "none" : "";}
            // if (footer[0] !== undefined) {footer[0].style.display = toggle ? "none" : "";}
            // if (thead[0] !== undefined)   thead[0].style.display = toggle ? 'none' : '';
            // if (tfoot[0] !== undefined)   tfoot[0].style.display = toggle ? 'none' : '';

            me.tfoot_c.toggle(total >= 2);
            me.footer.toggle(total > 1);
            me.thead_c.toggle(total > 0);

            me.thead
                .closest('.xtable-c')
                .toggleClass('xtable--no-results', toggle);
        };

        if (norecords) {
            tbody.append(norecords);

            hide(true);

            me._updateScrollers();
            return false;
        } else {
            hide(false);
        }

        return true;
    }
    paginate(page) {
        /** Deprecated metodas */
        this.loadPage(page);
    }
    /**
     * Pakrauna norimą puslapį, jeigu puslapis nepaduotas, kraunamas 1 puslapis
     * @param {number} page - puslapio numeris
     */
    loadPage(page = 1) {
        var me = this,
            length = $('select.simple', me.footer).val(),
            start = page * length - length,
            paging = {
                page,
                start,
                length
            };

        me.ajaxchangedata(paging); // tikrinti, nebeveike sukeiciant, gramatines klaidos length
        me.setStorage('paging', paging);

        me.ajaxload();
    }
    renderPagination(records, filtered, total) {
        var me = this,
            footer = me.footer,
            perpage = me.storage.paging.length || me.config.pagelength,
            pages = Math.ceil(filtered / perpage),
            lang = this.lang,
            langp = lang.paging,
            langr = lang.records;

        $('.footer-left', footer).html(
            `
                ${langr.show}:
                <span class="recordsFiltered">
                    ${
                        records == filtered
                            ? records
                            : records +
                              ' ' +
                              langr.of +
                              ' ' +
                              filtered.commafy()
                    }
                </span>
                ${
                    filtered != total
                        ? '<span class="text-helper">' +
                          langr.total +
                          '<span class="recordsTotal"> ' +
                          total +
                          '</span>' +
                          '</span>'
                        : ''
                }
            `
        );
        // jei irasu maziau nei 10, kam rodyt?
        if (total < 10) {
            $('.perpage', footer).hide();
        } else {
            // iš mažo filtro sąrašo (<10) grįžtam prie didelio (>300)
            $('.perpage', footer).show();
        }

        if (
            me.pages != pages &&
            $('.xtable-pagination li', footer).length !== 0
        ) {
            // $('.tools .footer-right', footer).hide();
            $('.xtable-pagination', footer).twbsPagination('destroy');
        }

        if (pages > 1) {
            let pagination = $('.xtable-pagination', footer);

            pagination.twbsPagination('destroy'); // kitaip atsimena iš anksčiau nustatymus ir nepakeičia startPage
            pagination.twbsPagination({
                startPage:
                    pages <= (me.storage.paging.page || 1)
                        ? pages
                        : me.storage.paging.page || 1, // xbug <--- turi uzsetinti maziau nei yra totalpages, jei istrins ar pan.
                first                 : langp.first,
                prev                  : langp.prev,
                next                  : langp.next,
                last                  : langp.last,
                paginationClass       : '',
                totalPages            : pages,
                visiblePages          : 4,
                initiateStartPageClick: false,
                onPageClick           : function(event, page) {
                    me.loadPage(page);
                }
            });
        }

        me.pages = pages;
    }
    rendererHTMLButtons(html) {
        var wrap = '<div>' + html + '</div>',
            del = $('a[data-action=delete]', wrap),
            simple = $('a[data-reload=true]', wrap),
            btn_classes = ['btn', 'btn-xs', 'btn-icon', 'btn-hover'],
            temp,
            string = '',
            me = this,
            t = $.parseHTML(html.trim());

        $.each(t, function() {
            var action = $(this);

            if (action[0].nodeName === '#text') {
                string += action[0].textContent;
                return true;
            }

            if (
                me.moduleRights &&
                me.moduleRights.IsDelete === 0 &&
                action.data('action') === 'delete'
            ) {
                string += '';
                return true;
            } else if (action.data('action') === 'edit') {
                temp = action.clone(); // kada reikia gauti naujo ir seno kunus - abu vienodi, hei padarai =

                temp.append('<i class="fa fa-pencil"></i>');

                btn_classes.push('btn-primary');

                temp.addClass(btn_classes.join(' '));

                if (!temp.hasClass('open')) {
                    temp.addClass('modalwin');
                }

                temp.attr('data-pk', '$pk');

                string += temp[0].outerHTML;
            } else if (action.data('action') === 'delete') {
                // Toks baisus įgyvendinimas, dėl to, kad reikia grąžinti HTML kodą
                // string formatu
                var callback = 'xcrud.deleteRecord(\'[0]\', \'[1]\', \'$pk\', null, function(){ $(\'[2]\').xGrid().loadPage();})'.formatData(
                    [me.config.table, me.config.pk, me.selector]
                );

                temp = del.clone();

                btn_classes.push('btn-danger');

                temp
                    .addClass(btn_classes.join(' '))
                    .attr({
                        href   : 'javascript:;',
                        onclick: callback
                    })
                    .append('<i class="fa fa-times"></i>');

                string += temp[0].outerHTML;
            } else {
                string += this.outerHTML || '';
            }
        });

        return string;
    }
    /** Parsina paduotą HTML su atitinkamomis reikšmėmis iš {keys[0]: values[0]}.
     * Esmė: $ClientName -> UAB „Lexita“
     * @param {string} html
     * @param {array}  keys
     * @param {array}  values
     * @param {number} pk
     * @param {number} index
     * @return {string}
     */
    rowReplaceData(html, keys, values, pk, index) {
        var value = html.replace(/\$pk/gm, pk),
            htmlreplaces = value.match(/\$(\w+)/g); // --> $DocumentId, $HasDocuments ...

        if (!htmlreplaces) return value;

        for (var l = 0; l < htmlreplaces.length; l++) {
            var find = htmlreplaces[l], // --> $DocumentIdxczx
                repl = find.replace('$', ''),
                idex = keys.indexOf(repl);
            if (idex !== -1) {
                var temp = values[idex] === null ? '' : values[idex];

                value = value.replace(
                    new RegExp('\\' + find, 'g'),
                    typeof temp == 'string' ? temp.replace(/,/g, '&#44;') : temp
                ); // <-- reiksme
            } else if (find === '$data') {
                var me = this;
                value = value.replace(find, () => {
                    return JSON.stringify(me.getRowData(index)).replaceAll(
                        '"',
                        '\''
                    );
                });
            }
        }

        return value.replace(
            new RegExp('<div data-renderif="(0=1|1=0|0|=|)">(.*?)</div>', 'g'),
            ''
        ); // paskutinis | reikalingas
    }
    /** Parengia puslapio HTML
     * @param {array} pageData
     * @return {string}
     */
    renderPage(pageData) {
        var me = this,
            columns = me.columnsnow,
            columnsindexes = me.columnsnowindexes,
            pk_index = me.pk_index,
            spacer = me.spacer[0].outerHTML,
            rows = '',
            last_group = '...', // xgrid_grouping
            row;

        // Render Widths row
        var widths_row = pageData[0].map((value, index) => {
            // render fake row for widths;
            var col = columns[index];
            if (col.visible === 'false') {
                return false;
            }

            return (
                '<td style="width: ' +
                col.width +
                'px" data-name="' +
                columns[index].alias +
                '" data-column="' +
                (index + 1) +
                '"></td>'
            );
        });

        widths_row.push(spacer);

        widths_row = '<tr class="widths-row">' + widths_row.join('') + '</tr>';

        // Render Row
        for (var i = 0; i < pageData.length; i++) {
            var rowData = pageData[i],
                pk = rowData[pk_index],
                rowclass,
                rowtitle;

            if (me.grouping) {
                var grouping = me.grouping.displayIndex,
                    group = rowData[grouping - 1],
                    renderRowIndex = me.grouping.renderRowIndex;

                if (last_group != group) {
                    last_group = group;

                    rows += `
                        <tr class="group" data-groupid="${
                            rowData[
                                columnsindexes.indexOf(me.config.grouping.value)
                            ]
                        }">
                            <td colspan="${me.visiblecolumns + 1}">
                                <div>${group}</div>
                            </td>
                        </tr>
                    `;

                    if (rowData[renderRowIndex] === null) {
                        continue;
                    }
                }
            }

            // Formuojame <td> elementų masyvą iš rowData  // ['<td/>', '<td/>', ...]
            row = rowData.map((value, index) => {
                var col = columns[index];

                if (col.rowclass) rowclass = value || '';
                if (col.rowtitle) rowtitle = value || '';

                return me.renderCell(value, col, rowData, index);
            });

            row.push(spacer);

            var classes = [];
            rowclass ? classes.push(rowclass) : '';
            me.obj.rowclick ? '' : classes.push('not-clickable');

            // Implode row masyvą (<td/> elementus) į <tr/>
            row =
                '<tr ' +
                'data-rowid="' +
                pk +
                '"' +
                (classes.length > 0
                    ? 'class="' + classes.join(' ') + '"'
                    : '') +
                (rowtitle ? 'title="' + rowtitle + '"' : '') +
                '>' +
                row.join() +
                '</tr>';

            rows += me.rowReplaceData(row, columnsindexes, rowData, pk, i);
        }

        return widths_row + rows;
    }
    renderCell(value, col, rowData, rowIndex) {
        var me = this;
        var rowPk = rowData[me.pk_index];
        var hidden = col.hidden;
        var filter = me.storage.filter;
        var columnsindexes = me.columnsnowindexes;

        const beautify = str => {
            if (/\$\w\w+/.test(str)) return ''; // xbug, kai $ContactName
            return str
                .replace(/\s\s+/g, ' ')
                .replace(/\$\w\w+/, '')
                .trim();
        };

        const setTitle = td => (td.title = beautify(td.textContent));

        if (hidden === true) {
            return '<td style="display:none"></td>';
        }

        if (col.zero && value == 0) {
            value = '';
        }

        if (col.visible === 'false') {
            // != 'visible'
            return true;
        }

        var td = document.createElement('td');

        // Add classes
        if (col.clas !== undefined) {
            // td.classList.add(col.clas);
            col.clas.split(' ').forEach(function(a) {
                td.classList.add(a);
            });
        }

        if (col.renderer === 'html' || col.renderer === 'checkbox') {
            if (col.renderif !== undefined) {
                // renderint checkboxus, jei jo alias'as lygus 1 jei paduotas renderif
                var alias_index = columnsindexes.indexOf(col.renderif);
                if (rowData[alias_index] === 0) {
                    td.innerHTML = '';
                } else {
                    td.innerHTML = col.html;
                }
            } else {
                td.innerHTML = col.html;
            }

            td.classList.add('html');

            if (col.renderer === 'checkbox') {
                td.innerHTML = me._wrap(td.innerHTML, 'label');
            } else {
                td.innerHTML = me._wrap(td.innerHTML);
            }

            setTitle(td);

            if (col.type === 'number' && col.renderer !== 'checkbox') {
                // crm.activity xbug dar reikia taisyti
                return me
                    .rowReplaceData(
                        td.outerHTML,
                        columnsindexes,
                        rowData,
                        rowPk,
                        rowIndex
                    )
                    .commafy();
            }

            return !hidden
                ? td.outerHTML
                : '<td class="html" style="display:none">' + col.html + '</td>';
        } else if (col.renderer === 'img') {
            if (rowData[columnsindexes.indexOf(col.html)]) {
                var img = me.rowReplaceData(
                    '$' + col.html,
                    columnsindexes,
                    rowData,
                    rowPk,
                    rowIndex
                ); // jei nereplacinu - pirma karta iesko image
                // mfp rendereriui
                if (img.indexOf('upload') > -1) {
                    img = img.replace('upload/', 'upload/cache/100x100/');
                }

                if (col.mfp === true) {
                    td.innerHTML =
                        '<img src="' +
                        img +
                        '" data-mfp-src="' +
                        img +
                        '" style="max-width:100px; max-height:50px; float: right;">';
                } else {
                    td.innerHTML =
                        '<img src="' +
                        img +
                        '" style="max-width:100px; max-height:50px; float: right;">';
                }

                if (col.col !== col.index) {
                    td.innerHTML = td.innerHTML + value;
                }
            } else if (!value || col.col === col.index) {
                // return td.outerHTML;
            } else {
                td.innerHTML = value;
            }

            td.innerHTML = me._wrap(td.innerHTML);
            setTitle(td);

            return !hidden
                ? td.outerHTML
                : '<td style="display:none">' + td.innerHTML + '</td>';
        } else if (col.type === 'function') {
            value = me.rowReplaceData(
                col.html,
                columnsindexes,
                rowData,
                rowPk,
                rowIndex
            );

            var parameters = value.match(/\(([\s\S]+)\)/gi); // --> ("a", "tree") arba null

            if (parameters === null) return;

            var tempval = parameters[0], // '/\((.*)\)/gmi'
                fnstring = value.replace(tempval, ''),
                fnparams = tempval.slice(1, -1).split(', '), // xaltura replacinimas su tarpu siek tiek blogai
                fn = window[fnstring];

            $.each(fnparams, function(i, v) {
                if (v == 'null') {
                    fnparams[i] = null;
                }

                if (v == 'this') {
                    fnparams[i] = td;
                }
            });

            if (typeof fn === 'function') {
                value = fn(...fnparams);
            } else {
                value = '';
            }

            td.innerHTML = me._wrap(value);
            setTitle(td);

            return !hidden
                ? td.outerHTML
                : '<td style="display:none">' + value + '</td>';
        } else if (col.renderer === 'xeditable') {
            return (
                '<td ' +
                (hidden ? 'style="display:none")' : '') +
                ' class="editable" title="Spauskit jeigu norėdami pakeisti">' +
                me._wrap(
                    '<div class="xeditable" data-form="' +
                        col.edit +
                        (col.edit.indexOf('?') === -1 ? '/' : '') +
                        rowPk +
                        '" data-field="' +
                        col.alias +
                        '">' +
                        (value || '') +
                        '</div>'
                ) +
                '</td>'
            );
        }

        if (!value && value !== 0) {
            // display 0
            return !hidden
                ? '<td>' + me._wrap(td.innerHTML) + '</td>'
                : '<td style="display:none"></td>';
        }

        if (col.type === 'money' || col.type === 'number') {
            if (me.fixedRound !== undefined && col.type == 'money') {
                value = Number(value)
                    .toFixed(me.fixedRound)
                    .commafy();
            } else if (col.round) {
                value =
                    '~' +
                    value
                        .toFixed(col.round)
                        .toString()
                        .commafy();
            } else {
                value = value.toString().commafy();
            }
        } else if (/x?switch/i.test(col.type) === true) {
            td.classList.add('switch');
            td.innerHTML = me._wrap(
                `<input
                    data-type="xswitch"
                    data-on="${col.on}"
                    data-off="${col.off}"
                    data-toggle="toggle"
                    ${value == '1' ? 'checked' : ''}
                />`
            );
            return td.outerHTML;
        }

        if (col.renderer) {
            value = me.renderer(value, col.renderer);
        }

        if (filter[col.search || col.alias]) {
            value = me.mark(
                value,
                filter[col.search || col.alias].split(':')[1]
            );
        }

        td.innerHTML = value;

        if (col.bool === true) {
            if (value == 1) {
                td.innerHTML = '<i class="fa fa-fw fa-check"></i>';
            } else {
                td.innerHTML = '';
            }
        }

        td.innerHTML = me._wrap(td.innerHTML);
        setTitle(td);

        return !hidden
            ? td.outerHTML
            : '<td style="display:none">' + td.innerHTML + '</td>';
    }
    ajaxload() {
        this.xhr = $.ajax(this.ajax);
    }
    ajaxchangedata(data) {
        $.extend(this.ajax.data, data);
    }
    getStorage() {
        let sk = this.storageKey;

        this.storage = {
            archive        : xstorage.getobjkey('archive', sk),
            columnswidth   : xstorage.getobjkey('columnswidth', sk),
            custom_where   : xstorage.getobjkey('custom_where', sk),
            filter         : xstorage.getobjkey('filter', sk),
            paging         : xstorage.getobjkey('paging', sk),
            record         : xstorage.getobjkey('record', sk),
            related_control: xstorage.getobjkey('related_control', sk),
            sort           : xstorage.getobjkey('sort', sk),
            userconfig     : xstorage.getobjkey('userconfig', sk)
        };

        return this.storage;
    }
    setStorage(type, obj) {
        var me = this,
            storage = me.storage;

        switch (type) {
            case 'filter':
                $.extend(storage.filters, obj);
                $.extend(storage.paging, {
                    page : 1,
                    start: 0
                });
                $.extend(me.ajax.data, {
                    filter: xhelper.obj.toArray(storage.filter).join(';')
                });
                break;
            case 'custom_where':
                $.extend(storage.custom_where, obj);
                $.extend(me.ajax.data, {
                    custom_where: xhelper.obj
                        .toArray(storage.custom_where)
                        .join(';')
                });
                break;
            case 'sort':
                $.extend(storage.sort, obj);

                if (me.config.orderbyForced) {
                    $.extend(me.ajax.data, {
                        orderby: me.config.orderbyForced + ',' + obj.orderby
                    });
                } else {
                    $.extend(me.ajax.data, obj);
                }
                break;
            case 'record':
                $.extend(storage.record, obj);
                $.extend(me.ajax.data, obj);
                break;
            case 'paging':
                $.extend(storage.paging, obj);
                $.extend(me.ajax.data, obj);
                break;
            case 'userconfig':
                $.extend(storage.userconfig, {
                    userconfig: obj
                });
                break;
            case 'columnswidth':
                break;
            case 'archive':
                storage.archive = obj;
                break;
            case 'related_control':
                storage.related_control = obj;
                break;
            default:
                log('Incorrect set type');
        }

        var regex = new RegExp('\\/(\\d+)'),
            match = regex.exec(location.pathname);

        if (
            me.config.localStorage !== true &&
            match &&
            match[1] &&
            pk === match[1]
        ) {
            // kur yra pk atjungiamas localStorage nebent config nurodyta kitaip
            return;
        }

        xstorage.setobjkey(type, me.storageKey, obj);
    }

    renderer(value, type) {
        if (type == 'mail') {
            return (
                '<a title="' +
                value +
                '" href="mailto:' +
                value +
                '">' +
                value +
                '</a>'
            );
        } else if (type.indexOf('fa ') !== -1) {
            // icon
            return value === 1 ? type : '';
        }

        return value + ' ' + type;
    }
    showHideColumns(li, index, isActive, e) {
        const { thead, tfoot, storage, columns } = this;
        const { columnswidth } = storage;

        const column = columns[index];

        const th = $('th[data-index="' + index + '"]', thead);
        const th_index = th.index();

        var me = this,
        
			tbody = me.tbody,

			widths = storage.columnswidth,
			sindex = me.selectindexes.indexOf(column.alias),
			tr = $('tr:first', thead);

        // tapo nematomas
        if (isActive === true) {
            $('th:nth-child('+(th_index+1)+')', thead).add(
				$('td:nth-child('+(th_index+1)+')', tfoot)
			).hide();

			$('td:nth-child('+(sindex+1)+')', tbody).remove(); //pagal select indexa

			me.select.splice(sindex, 1);
			me.selectindexes.splice(sindex, 1);
			column.visible = 'optional';
			column.hidden = true;

			me.visiblecolumns--;
			me.modifyselect(true);
        } else {
            // tapo matomas
            const tr = $('tr:first', thead);
            const prev = th.prevAll(':visible:first'); // matomas prieš pasirinktą
            const visible = tr.find('th:visible'); // visi kurie yra matomi
            const prIndex = visible.index(prev) + 1;

            $('th:nth-child(' + (th_index + 1) + ')', thead)
                .add($('th:nth-child(' + (th_index + 1) + ')', tfoot))
                .each((_, el) => {
                    if (el.getAttribute('data-col')) {
                        this._getColumnWidthPreset(
                            el, //this, pj*
                            th_index,
                            columnswidth,
                            true
                        );
                    }
                    // this.style.display = '';  pj*
                    el.style.display = '';
                });

            this.select.splice(prIndex, 0, column.col);
            this.selectindexes.splice(prIndex, 0, column.alias);

            column.visible = 'visible';
            column.hidden = false;

            this.visiblecolumns++;
            this.modifyselect(true);
            this.ajaxload();
        }

        this._updateAll();

        return th_index;
    }
    // showHideColumns2(li, index, isActive, e) {
    //     var me = this,
    //         thead = me.thead,
    //         tbody = me.tbody,
    //         tfoot = me.tfoot,
    //         storage = me.storage,
    //         widths = storage.columnswidth,
    //         column = me.columns[index],
    //         sindex = me.selectindexes.indexOf(column.alias),
    //         th = $('th[data-index="' + index + '"]', thead),
    //         th_index = th.index(),
    //         tr = $('tr:first', thead);

    //     // tapo nematomas

    //     if (isActive === true) {
    //         me.select.splice(sindex, 1);
    //         me.selectindexes.splice(sindex, 1);
    //         column.visible = 'optional';
    //         column.hidden = true;

    //         me.visiblecolumns--;
    //         me.modifyselect(true);
    //     } else {
    //         // tapo matomas
    //         var prev = th.prevAll(':visible:first'), // matomas prieš pasirinktą
    //             visible = tr.find('th:visible'), // visi kurie yra matomi
    //             prIndex = visible.index(prev) + 1;

    //         $('th:nth-child(' + (th_index + 1) + ')', thead)
    //             .add($('th:nth-child(' + (th_index + 1) + ')', tfoot))
    //             .each(function() {
    //                 if (this.getAttribute('data-col')) {
    //                     me._getColumnWidthPreset(this, th_index, widths, true);
    //                 }
    //                 this.style.display = '';
    //             });

    //         me.select.splice(prIndex, 0, column.col);
    //         me.selectindexes.splice(prIndex, 0, column.alias);

    //         column.visible = 'visible';
    //         column.hidden = false;

    //         me.visiblecolumns++;
    //         me.modifyselect(true);
    //         me.ajaxload();
    //     }

    //     me._updateAll();

    //     return th_index;
    // }
    getFixedFilter() {
        return this.ajax.data.fixedFilter;
    }
    changeFixedFilter(select, refresh = true) {
        console.log('changeFixedFilter | ', select);
        if (this.ajax.data.fixedFilter === select) return;
        
        var me = this;
        me.ajaxchangedata({
            fixedFilter: select
        });
        
        if (refresh === true) {
            me.loadPage();
        }
    }
    removeFixedFilter(select) {
        var me = this,
            reg = new RegExp(select + '.*?(;|$)');
        me.ajaxchangedata({
            fixedFilter: me.ajax.data.fixedFilter.replace(reg, '')
        });
        me.loadPage();
    }
    addFixedFilter(select) {
        var me = this;
        me.ajaxchangedata({
            fixedFilter: me.ajax.data.fixedFilter + ';' + select
        });
        me.loadPage();
    }
    combineFixedFilter(col, filter) {
        var me = this,
            reg = new RegExp(col + '.*?(;|$)');

        if (
            me.ajax.data.fixedFilter &&
            typeof me.ajax.data.fixedFilter === 'string'
        ) {
            me.changeFixedFilter(
                me.ajax.data.fixedFilter.replace(reg, '') +
                    (filter != undefined ? ';' + filter : '')
            );
        } else {
            me.changeFixedFilter(filter != undefined ? ';' + filter : '');
        }
    }
    custom_where(select) {
        var me = this;
        me.ajaxchangedata({
            custom_where: select
        });
        me.loadPage();
    }
    getTable() {
        return this.config.table;
    }
    setTable(table) {
        this.ajaxchangedata({
            table: table
        });
        this.ajaxload();
    }
    getCheckedValues(sep) {
        return $('input:checked', this.tbody)
            .toArray()
            .map(el => el.dataset.pk)
            .join(sep || ';');
    }
    exportExcel() {
        var me = this,
            ajax = me.ajax.data,
            data = JSON.stringify(me.columnsnow);

        ajax.config = data;

        xhelper.file.download('/php/excel/export.php', ajax);
    }
    removeGridFilters(param) {
        var me = this;
        xstorage.clear('filter', me.ajax.data.table);
        me.ajax.data.filter = null;
        me.ajax.data.fixedFilter = null;

        var input = me.thead.find('input.selected');
        input.val('');
        input.removeClass('selected');

        if (me.chead) {
            var inputCh = me.chead.find('input.selected');
            inputCh.val('');
            inputCh.removeClass('selected');
        }

        if (param !== false) {
            me.ajaxload();
        }
    }
    getRowData(i) {
        var me = this,
            columns = me.columnsnow;

        console.log(
            me.data[i].reduce(function(result, item, index) {
                result[columns[index].alias] = item;
                return result;
            }, {})
        );

        return me.data[i].reduce(function(result, item, index) {
            result[columns[index].alias] = item;
            return result;
        }, {});
    }
    // #region ---Utilities---
    /** Nustato stulpelio plotį. Būtini visi parametrai dėl performance
     * @param {HTMLElement} th // th element
     * @param {number} index column index
     * @param {array} widths localStorage widths (this.storage.columnswidth)
     * @param {number} totalWidth this.thead.parent()[0].offsetWidth
     * @return {number}
     */
    _getColumnSize(
        th,
        index,
        widths = this.storage.columnswidth,
        totalWidth = this.thead.parent().closestVisible(true)[0].offsetWidth
    ) {
        if (th.dataset.visible === 'false') {
            th.style.width = '';
            th.style.minWidth = '';
            th.style.maxWidth = '';
            return 0;
        } // hidden column

        return (
            0,
            widths[index] || // width saved in localStorage
            parseInt(th.style.width, 10) || // custom width in .tpl file via style attr. (+, kad cast į INT)
            this._getColumnWidthPreset(th) || // preset width (data-type="date")
            Math.max(th.offsetWidth - 1, 0) || // If no preset found (visible width)
            Math.round(totalWidth / this.visiblecolumns) || // if column not visible (justified width)
                th.textContent.length * 10 // If table not visible (auto width)
        );
    }
    /** Priklausomai nuo stulpelio tipo, nustatome jo plotį
     * pvz.: jeigu `date`, tai reikia mažesnio stulpelio.
     * @param {HTMLElement} th
     * @return {number | undefined}
     */
    _getColumnWidthPreset(th) {
        const type = th.dataset.type;

        switch (type) {
            case 'date':
                return 100;
            case 'time':
                return 80;
            case 'datetime':
                return 130;
        }
    }
    /** Keičia stulpelio plotį
     * @param {HTMLElement} th - stulpelio <th> elementas
     * @param {number} size - plotis, priskirtas stulpeliui
     * @param {number} visibleIndex - stulpelio <th> indeksas
     * @param {boolean} isResizing - Jeigu `true`, nustatome plotį ir <td> elementams
     * (reikia, kai turime jau užkrautus duomenys) (performance)
     */
    _setColumnWidth(th, size, visibleIndex, isResizing) {
        th = $(th);
        size = parseInt(size);

        var me = this,
            $th = $(th),
            index = $th.index();

        $th
            // add tfoot column
            .add(
                $('.xtable-summary', me.tfoot)
                    .find('th')
                    .eq(index)
            )
            // add tbody column
            .add(
                $('.widths-row', me.tbody)
                    .children()
                    .eq(visibleIndex)
            )
            .each(function() {
                this.style.width = size + 'px';
            });

        me.columns[visibleIndex].width = size;
        if (isResizing) {
            me._updateAll();
        }
    }
    _wrap(innerHTML, nodeName = 'div') {
        // return innerHTML;
        return '<' + nodeName + '>' + innerHTML + '</' + nodeName + '>';
    }
    _updateScrollers() {
        // Thead height = Thead Content Height
        // Tfoot height = Tfoot Content Height
        // Tbody height = Content Height || Window Height
        const { el, thead, thead_c, tbody, tbody_c, tfoot, tfoot_c } = this;

        // long ifs to prevent unnecessary layout paints

        // Set THEAD_C and TFOOT_C sizes, because childrens' positions are absolute
        if (
            thead_c.length &&
            thead_c[0].style.height != thead.parent()[0].offsetHeight + 'px'
        ) {
            thead_c[0].style.height = thead.parent()[0].scrollHeight + 'px';
        }

        if (
            tfoot_c.length &&
            tfoot_c[0].style.height != tfoot.parent().offsetHeight + 'px'
        ) {
            tfoot_c[0].style.height = tfoot.parent()[0].scrollHeight + 'px';
        }

        //pj 19.05.27 uzkomentinau ir ihardkodinau 1000 nes meta klaida laiko aiskintis nera ... XBUG
        // var maxWindowHeight =
        //     window.innerHeight -
        //     el.children('.xtable-footer')[0].clientHeight -
        //     el.children('.xtable-header')[0].clientHeight -
        //     (thead_c.length ? thead_c[0].clientHeight : 0) -
        //     (tfoot_c.length ? tfoot_c[0].clientHeight : 0) -
        //     16 - // content padding
        //     16 - // ?, probably some caption, footer borders
        //     (el.closest('#content').length ? $('#content').offset().top : 0);

        // tbody_c[0].style.height =  Math.min(tbody[0].scrollHeight, maxWindowHeight) + 'px';
        
        // Scroll to active row
        // this._scrollToActiveRow();
        
        tbody_c[0].style.height =  Math.min(tbody[0].scrollHeight, 1000) + 'px';

    }
    _scrollToActiveRow() {
        // If no data...
        if (
            typeof this.data === 'undefined' ||
            (this.data && this.data.length === 0)
        ) {
            return;
        }
        const { tbody, os_instance } = this;
        const $activeRow = $('.active-row', tbody);
        // If no row selected...
        if ($activeRow.length === 0) return;
        // Else scroll
        os_instance.scroll(
            {
                el    : $activeRow,
                axis  : 'y',
                block : ['begin', 'center'],
                margin: [128, 0, 0, 0]
            },
            0
        );
    }
    _scrollToEnd() {
        this.os_instance.scroll(
            {
                x: '100%'
            },
            0
        ); // OverlayScrollbars
    }
    _setTotalWidth() {
        let total = this._getColumnsWidth() + this._getEmptyWidth() + 'px';
        this.thead_c.height(this.thead_c[0].scrollHeight);
        this.tfoot_c.height(this.tfoot_c[0].scrollHeight);

        $('table', this.grid).each((index, table) => {
            table.style.width = total;
        });
    }
    _setEmptyWidth(size = this._getEmptyWidth()) {
        var spacer = this.spacer.add(
            this.tbody.find('.widths-row').children(':last')
        );

        size = Math.max(size, 0) + 'px';

        spacer.each(function(i, el) {
            if (el.style.width != size) {
                el.style.width = size;
            }
        });
    }
    /** Paskaičiuoja ir grąžina tuščio stulpelio plotį ()
     * @return {number}
     */
    _getEmptyWidth() {
        return Math.max(
            this.tbody_c.closestVisible(true)[0].offsetWidth -
                this._getColumnsWidth() -
                this.visiblecolumns,
            0
        );
    }
    /** Grąžina visų matomų stulpelių pločių sumą (neskaitant tuščio)
     * @return {number}
     */
    _getColumnsWidth() {
        return this.columns.reduce((sum, col) => {
            return sum + (col.isVisible && col.width ? parseInt(col.width) : 0);
        }, 0);
    }
    /** Patikrina, ar paduotas <th> elementas yra paskutinis matomas stulpelis
     * @param {HTMLElement} th
     * @return {boolean}
     */
    _isLastVisible(th) {
        return $(th).is(
            $(th)
                .parent()
                .children('th')
                .not('[data-type="spacer"], [data-renderer="checkbox"]')
                .filter(':visible:last')
        );
    }
    _updateAll() {
        this._setEmptyWidth();
        this._setTotalWidth();
        this._updateScrollers();
    }
    // #endregion

    get classes() {
        return {
            active_row: 'active-row',
            search    : {
                clear : 'searchclear',
                active: 'selected'
            }
        };
    }

    get templates() {
        const lang = this.lang;
        const perpage =
            (this.config && this.config.perpage) || this.defaults.perpage;

        let paging = '';

        for (let i = 0, pages = perpage; i < perpage.length; i++) {
            paging +=
                '<option value="' + pages[i] + '">' + pages[i] + '</option>';
        }

        return {
            footer: `
            <div class="xtable-footer">
                <div class="footer-left">-</div>
                <div class="footer-center">
                    <div class="perpage">
                        ${lang.records.perpage}
                        <div class="mx-auto">
                            <select class="simple" style="width:50px">
                                ${paging}
                            </select>
                        </div>
                    </div>
                </div>
                <div class="footer-right">
                    <a  href="javascript:;" class="export btn btn-hover btn-icon btn-flat ml-auto"
                        title="${lang.exportdata}"
                    >
                        <i class="fa fa-file-excel-o"></i>
                    </a>
                    <ul class="xtable-pagination p-0 m-0"></ul>
                </div>
            </div>`
        };
    }

    /** Grąžina unikalų `localStorage` raktą
     * @return {string}
     */
    get storageKey() {
        // Trim '/' ir '1234' (pk).
        // `/clients/overview/231` --> `clients/overview` --> `clients_overview`
        // Galų gale --> `clients_calls|sales`
        return (
            location.pathname
                .replace(/^[\W\d]+|[\d\W]+$/g, '')
                .replace(/\//g, '_') +
            '|' +
            this.selector
        );
    }
}
